import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cffe4b66")

_pushScopeId("data-v-cffe4b66")
const _hoisted_1 = { class: "bold mb1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t('common.settings')
    }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          class: "ml3",
          onClick: $setup.saveIceBreakerConfigSettings
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_BaseBox, {
      class: "admin-panel-icebreaker-settings",
      saving: $setup.saveLoading
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("b", null, _toDisplayString(_ctx.$t('funIceBreaker.settings.noOfQuestions')), 1)
        ]),
        _createVNode("div", null, [
          _createVNode(_component_Input, {
            modelValue: $setup.funIceBreakerSettings.defaultNoOfQuestions,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.funIceBreakerSettings.defaultNoOfQuestions = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["saving"])
  ], 64))
})